__turbopack_context__.v({
  "className": "inter_e7f9b31c-module__IEhUAG__className",
  "variable": "inter_e7f9b31c-module__IEhUAG__variable",
});
